import React from "react"
import clsx from "clsx"
import RichTextEditor from "../../RichTextEditor/RichTextEditor"
import I18n from "i18n-js"

class FormFieldBuilderDisplayOnly extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'display_only',
      'tab-pane': true 
    })

   
    return (
      <div className={tabClasses} id='display_only_text'>
        {this.renderDisplayOnlyText()}    
      </div>
    )
  }

  renderDisplayOnlyText() {
    return(
      <div className="col-md-6" key="display_only_text">
        <div className="form-group">
          <label>{I18n.t('display_only_text')}*<span className="ss-help help" title={I18n.t('display_only_helper_text')}></span> </label>
          <RichTextEditor height={230} name={this.inputName('display_only_text')} body={this.props.display_only_text} onChange={this.props.onChange.bind(this, 'display_only_text')} className={this.renderFieldClasses('display_only_text')}/>
        </div>
      </div> 

    )
  }

  inputName(name, obj) {
    var inputName = 'billing_policy';

    inputName = inputName + name;

    return inputName;
  }

  renderFieldClasses(field) {
    var classname = 'form-control';
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors';
    }
    return classname;
  }


}

export default FormFieldBuilderDisplayOnly